exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3ij0RQemp6EEWTtK87pXJ8,.mZKBZ7ePhyUwoEniTpwGo{font-size:12px;font-weight:400}.mZKBZ7ePhyUwoEniTpwGo{color:\"[theme:neutralPrimary, default:#333333]\";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:450px}._375eA2nLFVXcIH_PDf50jg{height:19px;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}html[dir] ._375eA2nLFVXcIH_PDf50jg{border:none;padding:0}._3sxZ1SKAzHGXuIxYD2_l0l{-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}html[dir=ltr] ._3sxZ1SKAzHGXuIxYD2_l0l{padding-right:3px}html[dir=rtl] ._3sxZ1SKAzHGXuIxYD2_l0l{padding-left:3px}._2RvrCZzsS7CabOo6Z82qfG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"commandButtonTextLabel": "_3ij0RQemp6EEWTtK87pXJ8",
	"menuItemText": "mZKBZ7ePhyUwoEniTpwGo",
	"multipleOptionCommandButton": "_375eA2nLFVXcIH_PDf50jg",
	"preActionText": "_3sxZ1SKAzHGXuIxYD2_l0l",
	"mainContainer": "_2RvrCZzsS7CabOo6Z82qfG"
};